import * as Yup from 'yup';

export const UserAuthenticationSchema:any = Yup.object().shape({
    lockerNumber: Yup.string().required(),
    passCode: Yup.string().nullable(),
}); 

export const FingerCheckOutSchema:any = Yup.object().shape({
    fingerTemplate: Yup.string().required(),
});
